import { onUnmounted, watch } from 'vue'
import type { Ref } from 'vue'

/**
 * Toggle a class on `document.body` based on a reactive boolean. The class is
 * always removed on unmount so a closing component never leaves stale chrome
 * behind.
 */
export default function useBodyClass(
  className: string,
  active: Ref<boolean>
): void {
  watch(
    active,
    (isActive) => {
      document.body.classList.toggle(className, isActive)
    },
    { immediate: true }
  )

  onUnmounted(() => {
    document.body.classList.remove(className)
  })
}
